import { Search } from 'lucide-react';

const SearchBar = ({ value, onChange, placeholder = 'Buscar...' }) => (
    <div style={{ position: 'relative', flex: 1, minWidth: 200 }}>
        <Search
            size={16}
            style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: 'var(--sp-muted)' }}
        />
        <input
            className="sp-field__input"
            style={{ paddingLeft: '2.3rem', width: '100%' }}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
        />
    </div>
);

export default SearchBar;